// これはグローバルなフィルタです。
// main.tsにて読み込んで、mixinしてあります。numa
export default {
  testFilter(value: any) {
    return "OK" + value; //テストFilter
  },
  monthNumber(datedata: Date) {
    return datedata.getMonth(); //月を取得
  },
  moneyDelemiter(value: number) {
    return Number(value).toLocaleString(); //3桁区切りでカンマをつける
  },
  capitalize(value: any) {
    if (!value) return "";
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1); //キャピタライズ
  },
  slicehead(word: any, n: number) {
    return word.slice(0, n); //あたまからn文字数表示（ブロックからはみ出る場合）
  },
  zenkakuToHankaku(beforetext: string) {
    let zen = new Array(
      "ア",
      "イ",
      "ウ",
      "エ",
      "オ",
      "カ",
      "キ",
      "ク",
      "ケ",
      "コ",
      "サ",
      "シ",
      "ス",
      "セ",
      "ソ",
      "タ",
      "チ",
      "ツ",
      "テ",
      "ト",
      "ナ",
      "ニ",
      "ヌ",
      "ネ",
      "ノ",
      "ハ",
      "ヒ",
      "フ",
      "ヘ",
      "ホ",
      "マ",
      "ミ",
      "ム",
      "メ",
      "モ",
      "ヤ",
      "ヰ",
      "ユ",
      "ヱ",
      "ヨ",
      "ラ",
      "リ",
      "ル",
      "レ",
      "ロ",
      "ワ",
      "ヲ",
      "ン",
      "ガ",
      "ギ",
      "グ",
      "ゲ",
      "ゴ",
      "ザ",
      "ジ",
      "ズ",
      "ゼ",
      "ゾ",
      "ダ",
      "ヂ",
      "ヅ",
      "デ",
      "ド",
      "バ",
      "ビ",
      "ブ",
      "ベ",
      "ボ",
      "パ",
      "ピ",
      "プ",
      "ペ",
      "ポ",
      "ァ",
      "ィ",
      "ゥ",
      "ェ",
      "ォ",
      "ャ",
      "ュ",
      "ョ",
      "ッ",
      "゛",
      "°",
      "、",
      "。",
      "「",
      "」",
      "ー",
      "・"
    );

    let han = new Array(
      "ｱ",
      "ｲ",
      "ｳ",
      "ｴ",
      "ｵ",
      "ｶ",
      "ｷ",
      "ｸ",
      "ｹ",
      "ｺ",
      "ｻ",
      "ｼ",
      "ｽ",
      "ｾ",
      "ｿ",
      "ﾀ",
      "ﾁ",
      "ﾂ",
      "ﾃ",
      "ﾄ",
      "ﾅ",
      "ﾆ",
      "ﾇ",
      "ﾈ",
      "ﾉ",
      "ﾊ",
      "ﾋ",
      "ﾌ",
      "ﾍ",
      "ﾎ",
      "ﾏ",
      "ﾐ",
      "ﾑ",
      "ﾒ",
      "ﾓ",
      "ﾔ",
      "ｲ",
      "ﾕ",
      "ｴ",
      "ﾖ",
      "ﾗ",
      "ﾘ",
      "ﾙ",
      "ﾚ",
      "ﾛ",
      "ﾜ",
      "ｦ",
      "ﾝ",
      "ｶﾞ",
      "ｷﾞ",
      "ｸﾞ",
      "ｹﾞ",
      "ｺﾞ",
      "ｻﾞ",
      "ｼﾞ",
      "ｽﾞ",
      "ｾﾞ",
      "ｿﾞ",
      "ﾀﾞ",
      "ﾁﾞ",
      "ﾂﾞ",
      "ﾃﾞ",
      "ﾄﾞ",
      "ﾊﾞ",
      "ﾋﾞ",
      "ﾌﾞ",
      "ﾍﾞ",
      "ﾎﾞ",
      "ﾊﾟ",
      "ﾋﾟ",
      "ﾌﾟ",
      "ﾍﾟ",
      "ﾎﾟ",
      "ｧ",
      "ｨ",
      "ｩ",
      "ｪ",
      "ｫ",
      "ｬ",
      "ｭ",
      "ｮ",
      "ｯ",
      "",
      "",
      "､",
      "｡",
      "｢",
      "｣",
      "ｰ",
      "･"
    );

    let aftertext = "";

    for (let i = 0; i < beforetext.length; i++) {
      let beforechar = beforetext.charAt(i);
      let zenindex = zen.indexOf(beforechar);
      if (zenindex >= 0) {
        beforechar = han[zenindex];
      }
      aftertext += beforechar;
    }

    return aftertext;
  }
};
